export default "__VITE_ASSET__f8c3d1c4__"